import React from 'react'
import { Flex, Box, Heading, Text, Button } from 'rebass/styled-components'
import styled from 'styled-components'
import { Input, Textarea } from '@rebass/forms/styled-components'
import { useForm } from 'react-hook-form';

const SalesEnquiry = styled(Flex)`
    div {
        align-self: flex-start;
        flex-basis: 50%;
        flex-grow: 1;

        @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
            width: 100%;

            button {
                display: block;
                width: 192px;
            }
        }
    }
`
const SalesForm = ({ sendMail }) => {
    const url = typeof window !== 'undefined' ? window.location.href : 'Referring URL not available'
    const { register, handleSubmit, formState: { errors }} = useForm();
    const onSubmit = (data) => sendMail(data, 'contact_form');
    return (
        <Flex
            alignItems="flex-start"
            flexDirection={['row', 'row', 'row', 'row', 'row', 'row', 'row']}
            mb="lg"
            name="salesFormRef" // This is for ScrollTo to work.
        >
            <Box
                // bg="aquaMedium" // designed to receive backgroundColor property
                bg="white"
                display={['none', 'none', 'block', 'block', 'block', 'block', 'block']}
                flexGrow="1"
                height="100px"
                sx={{
                    minWidth: '30px',
                }}
            >
                &#160;
            </Box>
            <Box
                alignSelf="stretch"
                bg="white"
                flexBasis={['auto', 'auto', '80%', '80%', '80%', '80%', '80%']}
                flexGrow="1"
                ml={['sm', 'sm', 'sm', 'md', 'lg', 'lg', 'lg']}
                mr={['sm', 'sm', 'sm', 'md', 'lg', 'lg', 'lg']}
                pt="md"
                pb="md"
                sx={{
                    maxWidth: '1160px',
                }}
            >
                <Heading
                    as="h2"
                    variant="h2"
                    pb="md"
                    sx={{
                        textTransform: 'uppercase',
                    }}>Consignment Enquiry</Heading>
                <SalesEnquiry
                    alignContent="space-between"
                    alignItems="flex-start"
                    as="form"
                    autocomplete="on"
                    flexDirection={['column', 'column', 'row', 'row', 'row', 'row', 'row']}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <Input type="hidden" name="subject" value="New Sales Enquiry" {...register('subject')} />
                    <Input type="hidden" name="referrer" value={url} {...register('referrer')} />
                    <Box
                        mr={['0', '0', 'sm', 'sm', 'md', 'md', 'md']}
                    >
                        <Text
                            as="label"
                            htmlFor="form-name"
                            hidden
                        >
                            Name
                        </Text>
                        <Input autoComplete="name" enterKeyHint="next" id="form-name" type="text" name="from_name" placeholder="Name" {...register('from_name', { required: true })} />
                        {errors.from_name && <span className="errorMessage">Please enter your name.</span>}

                        <Text
                            as="label"
                            htmlFor="form-email"
                            hidden
                        >
                            Email
                        </Text>
                        <Input autoComplete="email" enterKeyHint="next" id="form-email" type="email" name="reply_to" placeholder="Email" {...register('reply_to', { required: true })} />
                        {errors.reply_to && <span className="errorMessage">Please enter a valid email.</span>}

                        <Text
                            as="label"
                            htmlFor="form-tel"
                            hidden
                        >
                            Telephone
                        </Text>
                        <Input autoComplete="tel" enterKeyHint="next" id="form-tel" type="tel" name="phone" placeholder="Phone" {...register('phone', { required: true })} />
                        {errors.phone && <span className="errorMessage">Please enter a contact number.</span>}

                        <Text
                            as="label"
                            htmlFor="form-manufacturer"
                            hidden
                        >
                            Vehicle manufacturer
                        </Text>
                        <Input type="text" enterKeyHint="next" id="form-manufacturer" name="manufacturer" placeholder="Vehicle manufacturer" {...register('manufacturer')} />

                        <Text
                            as="label"
                            htmlFor="form-model"
                            hidden
                        >
                            Vehicle model
                        </Text>
                        <Input type="text" enterKeyHint="next" id="form-model" name="model" placeholder="Vehicle model" {...register('model')} />
                    </Box>
                    <Box
                        mt={['md', 'md', '0', '0', '0', '0', '0']}
                        ml={['0', '0', 'sm', 'sm', 'md', 'md', 'md']}
                    >
                        <Text
                            as="label"
                            htmlFor="form-comments"
                            hidden
                        >
                            Comments
                        </Text>
                        <Textarea
                            enterKeyHint="next"
                            id="form-comments"
                            name="message"
                            placeholder="Comments"
                            type="textarea" {...register('message', { required: true })}
                            sx={{
                                borderColor: 'aquaMedium',
                                overflow: 'auto',
                                minHeight: '115px',
                                resize: 'vertical',
                            }}
                        />
                        {errors.message && <span className="errorMessage">Please write a brief message so we can respond as swiftly as possible.</span>}
                        <Button
                            aria-pressed="false"
                            enterKeyHint="done"
                            ml="auto"
                            mr="auto"
                            mt="md"
                            type="submit"
                            variant="primary"
                        >Submit</Button>
                    </Box>
                </SalesEnquiry>
            </Box>
            <Box
                // bg="aquaMedium" // designed to receive backgroundColor property
                bg="white"
                display={['none', 'none', 'block', 'block', 'block', 'block', 'block']}
                flexGrow="1"
                height="100px"
                sx={{
                    minWidth: '30px',
                }}
            >
                &#160;
            </Box>
        </Flex>
    )
}

export default SalesForm
